const types = {
  BOOK_TRUCKS_START: 'BOOK_TRUCKS_START',
  BOOK_TRUCKS_SUCCESS: 'BOOK_TRUCKS_SUCCESS',
  BOOK_TRUCKS_FAILURE: 'BOOK_TRUCKS_FAILURE',
};

export default types;
